import { CommonHelper } from "../helpers";
export default {
  setInvestmentProjections(payload) {
    let p = {};
    p.investmentProjectionResult = [];
    for (let i = 0; i < payload.investmentProjectionResult.length; i++) {
      let investmentProjectionInfo = {};
      investmentProjectionInfo.investmentID =
        payload.investmentProjectionResult[i].investmentID;
      investmentProjectionInfo.totalIncomeReturn = parseFloat(
        payload.investmentProjectionResult[i].totalIncomeReturn == ""
          ? 0
          : payload.investmentProjectionResult[i].totalIncomeReturn
      );
      investmentProjectionInfo.totalGrowthReturn = parseFloat(
        payload.investmentProjectionResult[i].totalGrowthReturn == ""
          ? 0
          : payload.investmentProjectionResult[i].totalGrowthReturn
      );
      investmentProjectionInfo.totalContributions = parseFloat(
        payload.investmentProjectionResult[i].totalContributions == ""
          ? 0
          : payload.investmentProjectionResult[i].totalContributions
      );

      investmentProjectionInfo.totalWithdrawals = parseFloat(
        payload.investmentProjectionResult[i].totalWithdrawals == ""
          ? 0
          : payload.investmentProjectionResult[i].totalWithdrawals
      );
      investmentProjectionInfo.totalPlatformFees = parseFloat(
        payload.investmentProjectionResult[i].totalPlatformFees == ""
          ? 0
          : payload.investmentProjectionResult[i].totalPlatformFees
      );
      investmentProjectionInfo.totalAdviceFees = parseFloat(
        payload.investmentProjectionResult[i].totalAdviceFees == ""
          ? 0
          : payload.investmentProjectionResult[i].totalAdviceFees
      );

      investmentProjectionInfo.totalOtherFees = parseFloat(
        payload.investmentProjectionResult[i].totalOtherFees == ""
          ? 0
          : payload.investmentProjectionResult[i].totalOtherFees
      );
      investmentProjectionInfo.projectedValuePeriod = parseFloat(
        payload.investmentProjectionResult[i].projectedValuePeriod == ""
          ? 0
          : payload.investmentProjectionResult[i].projectedValuePeriod
      );

      investmentProjectionInfo.investmentProjection = [];
      for (
        let j = 0;
        j < payload.investmentProjectionResult[i].investmentProjection.length;
        j++
      ) {
        let investmentProjection = {};
        let projection =
          payload.investmentProjectionResult[i].investmentProjection[j];
        investmentProjection.year = projection.year;
        investmentProjection.openingBalance = projection.openingBalance;
        investmentProjection.contributionsSOM = projection.contributionsSOM;
        investmentProjection.withdrawalsSOM = projection.withdrawalsSOM;
        investmentProjection.incomeReturn = projection.incomeReturn;
        investmentProjection.growthReturn = projection.growthReturn;
        investmentProjection.frankingCredit = projection.frankingCredit;
        investmentProjection.dividendReinvested = projection.dividendReinvested;
        investmentProjection.contributionsEOM = projection.contributionsEOM;
        investmentProjection.withdrawalsEOM = projection.withdrawalsEOM;
        investmentProjection.platformFees = projection.platformFees;
        investmentProjection.adviceFees = projection.adviceFees;
        investmentProjection.otherFees = projection.otherFees;
        investmentProjection.contributionsEOMAuto =
          projection.contributionsEOMAuto;
        investmentProjection.withdrawalsEOMAuto = projection.withdrawalsEOMAuto;
        investmentProjection.closingBalance = projection.closingBalance;
        investmentProjection.costBaseStart = projection.costBaseStart;
        investmentProjection.costBaseClose = projection.costBaseClose;
        investmentProjection.incomeReturnPercent =
          projection.incomeReturnPercent;
        investmentProjection.growthReturnPercent =
          projection.growthReturnPercent;
        investmentProjection.frankingCreditPercent =
          projection.frankingCreditPercent;
        investmentProjection.contributionsAll = projection.contributionsAll;
        investmentProjection.withdrawalsAll = projection.withdrawalsAll;

        investmentProjection.incomeReturnCumulative =
          projection.incomeReturnCumulative;
        investmentProjection.growthReturnCumulative =
          projection.growthReturnCumulative;
        investmentProjection.incomeGrowthReturnCumulative =
          projection.incomeReturnCumulative + projection.growthReturnCumulative;
        investmentProjection.frankingCreditCumulative =
          projection.frankingCreditCumulative;
        investmentProjection.contributionsAllCumulative =
          projection.contributionsAllCumulative;
        investmentProjection.withdrawalsAllCumulative =
          projection.withdrawalsAllCumulative;

        investmentProjection.incomeGrowthNetFees =
          projection.incomeReturn +
          projection.growthReturn +
          projection.platformFees +
          projection.adviceFees +
          projection.otherFees;
        investmentProjection.incomeGrowthFees =
          projection.incomeReturn + projection.growthReturn;

        investmentProjection.fees =
          projection.platformFees +
          projection.adviceFees +
          projection.otherFees;

        investmentProjectionInfo.investmentProjection.push(
          investmentProjection
        );
      }
      p.investmentProjectionResult.push(investmentProjectionInfo);
    }
    return p;
  },
  getBalanceGraphData(InvestmentProjection) {
    let areachart = {
      minXAxis: 0,
      maxXAxis: InvestmentProjection.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
    };
    for (let i = 0; i < InvestmentProjection.length; i++) {
      let openingBalance = InvestmentProjection[i].openingBalance;
      if (areachart.maxYAxis < openingBalance) {
        areachart.maxYAxis = openingBalance;
      }
      if (i == 0)
        this.addAreaChartCoordinate(
          areachart,
          i,
          openingBalance,
          InvestmentProjection[i].incomeReturnCumulative,
          InvestmentProjection[i].year -1,
          InvestmentProjection[i].growthReturnCumulative
        );

      let closingBalance = InvestmentProjection[i].closingBalance;
      if (areachart.maxYAxis < closingBalance) {
        areachart.maxYAxis = closingBalance;
      }
      this.addAreaChartCoordinate(
        areachart,
        i + 1,
        closingBalance,
        InvestmentProjection[i].incomeReturnCumulative,

        InvestmentProjection[i].year ,
        InvestmentProjection[i].growthReturnCumulative
      );
    }

    return areachart;
  },

  addAreaChartCoordinate(
    areachart,
    index,
    balance,
    incomeReturnCumulative,
    year,
    growthReturnCumulative
  ) {
    areachart.data.push({
      id: index,
      value: {
        x: index,
        y: balance,
        title: [
          { value: "Year " + parseInt(index), class: "bold-text" },
          { value: "|" },
          {
            value: year,
            class: "bold-text",
          },
        ],
        tooltipText: [
          {
            id: "Balance",
            value: CommonHelper.convertIntoCurrencyWithoutDecimal(balance),
          },
          {
            id: "Income",
            value: CommonHelper.convertIntoCurrencyWithoutDecimal(
              incomeReturnCumulative
            ),
          },
          {
            id: "Growth",
            value: CommonHelper.convertIntoCurrencyWithoutDecimal(
              growthReturnCumulative
            ),
          },
        ],
      },
    });
  },
  getContributionWithdrawalGraph(InvestmentProjection) {
    let barchart = {
      minXAxis: 0,
      maxXAxis: InvestmentProjection.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
    };
    for (let i = 0; i < InvestmentProjection.length; i++) {
      let contributionsAll = parseFloat(
        InvestmentProjection[i].contributionsAll
      );
      let withdrawalsAll = parseFloat(InvestmentProjection[i].withdrawalsAll);

      if (barchart.maxYAxis < contributionsAll) {
        barchart.maxYAxis = contributionsAll;
      }
      if (barchart.minYAxis < -withdrawalsAll) {
        barchart.minYAxis = -withdrawalsAll;
      }
      barchart.data.push({
        id: i,
        title: `Year ${i + 1} | ${InvestmentProjection[i].year }`,
        value: [
          {
            id: "contributionsEOM_" + i,
            value: contributionsAll,
          },
          {
            id: "withdrawalsEOM_" + i,
            value: withdrawalsAll,
          },
        ],
        toolBarData: [
          { id: "Contribution", value: contributionsAll },
          { id: "Withdrawal", value: withdrawalsAll },
          { id: "Net", value: contributionsAll + withdrawalsAll },
        ],
      });
    }
    return barchart;
  },

  getReturnFeesData(InvestmentProjection) {
    let barchart = {
      minXAxis: 0,
      maxXAxis: InvestmentProjection.length,
      minYAxis: 0,
      maxYAxis: 0,
      data: [],
    };
    for (let i = 0; i < InvestmentProjection.length; i++) {
      let incomeAmount = parseFloat(InvestmentProjection[i].incomeReturn);
      let growthAmount = parseFloat(InvestmentProjection[i].growthReturn);
      let PositiveGrowthAmount = growthAmount > 0 ? growthAmount : 0;
      let feesAmount =
        parseFloat(InvestmentProjection[i].platformFees) +
        parseFloat(InvestmentProjection[i].adviceFees) +
        parseFloat(InvestmentProjection[i].otherFees);

      if (barchart.maxYAxis < incomeAmount + PositiveGrowthAmount) {
        barchart.maxYAxis = incomeAmount + PositiveGrowthAmount;
      }
      if (barchart.minYAxis < -growthAmount - feesAmount) {
        barchart.minYAxis = -growthAmount - feesAmount;
      }

      barchart.data.push({
        id: i,
        title: `Year ${i + 1} | ${InvestmentProjection[i].year }`,
        value: [
          {
            id: "Income" + i,
            value: incomeAmount,
          },
          {
            id: "Growth" + i,
            value: growthAmount,
          },
          {
            id: "Fees" + i,
            value: feesAmount,
          },
        ],
        toolBarData: [
          { id: "Income", value: incomeAmount },
          { id: "Growth", value: growthAmount },
          { id: "Fees", value: feesAmount },
          { id: "Net Return", value: incomeAmount + growthAmount + feesAmount },
          {
            id: "Franking Credit",
            value: InvestmentProjection[i].frankingCredit,
          },
        ],
      });
    }
    return barchart;
  },
};
